/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * UserRosterBase
 * auto generated base class for the model UserRosterModel.
 */
export const UserRosterModelBase = ModelBase.named('UserRoster')
  .props({
    __typename: types.optional(types.literal('UserRoster'), 'UserRoster'),
    avatar: types.union(types.undefined, types.string),
    email: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserRosterModelSelector extends QueryBuilder {
  get avatar() {
    return this.__attr('avatar')
  }
  get email() {
    return this.__attr('email')
  }
  get name() {
    return this.__attr('name')
  }
}
export function selectFromUserRoster() {
  return new UserRosterModelSelector()
}

export const userRosterModelPrimitives = selectFromUserRoster().avatar.email.name
